import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../utils/propUtils';
import VeltNotificationsPanelSettingsAccordionTriggerWireframe from './VeltNotificationsPanelSettingsAccordionTriggerWireframe/VeltNotificationsPanelSettingsAccordionTriggerWireframe';
import VeltNotificationsPanelSettingsAccordionContentWireframe from './VeltNotificationsPanelSettingsAccordionContentWireframe/VeltNotificationsPanelSettingsAccordionContentWireframe';
var VeltNotificationsPanelSettingsAccordionWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-settings-accordion-wireframe", __assign({}, transformedProps), children));
};
VeltNotificationsPanelSettingsAccordionWireframe.Trigger = VeltNotificationsPanelSettingsAccordionTriggerWireframe;
VeltNotificationsPanelSettingsAccordionWireframe.Content = VeltNotificationsPanelSettingsAccordionContentWireframe;
export default VeltNotificationsPanelSettingsAccordionWireframe;
